import {
  SET_SESSION_EXPIRED,
  SET_HAS_EXPRESS_DEAL,
  SET_OVERFILTERED_TIMESTAMP,
  SET_OVERFILTERED_BANNER_TEXT,
} from '../../actions/actionTypes'

const initialState = {
  overFilteredTimeStamp: null,
  sessionExpired: null,
  hasExpressDeal: false,
  setAttributeText: false,
}

const flags = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION_EXPIRED:
      return Object.assign({}, state, {
        sessionExpired: action.sessionExpired,
      })
    case SET_HAS_EXPRESS_DEAL:
      return Object.assign({}, state, {
        hasExpressDeal: action.hasExpressDeal,
      })
    case SET_OVERFILTERED_TIMESTAMP:
      return Object.assign({}, state, {
        overFilteredTimeStamp: action.overFilteredTimeStamp,
      })
    case SET_OVERFILTERED_BANNER_TEXT:
      return Object.assign({}, state, {
        setAttributeText: action.setAttributeText,
      })
    default:
      return state
  }
}

export { flags }
